/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,no-undef */
import React from "react";
import { connect } from "react-redux";
import { Nav, Tab } from "react-bootstrap";
import SideBarNavigationTabAction from './CustomControl/SideBarNavigationTabAction';
import PendingDraftGroup from './CustomControl/PendingDraftGroup';


class ContractSidePanelDrafts extends React.Component {
    state = { selectedTab: "1" };
    setTab = _tabName => {
        this.setState({ selectedTab: _tabName });
    };


    render() {
        if (!this.props.contractTemplate || !this.props.pendingDrafts) {
            return null;
        }
        const { contractTemplate, pendingDrafts } = this.props;

        return (
            <Tab.Container defaultActiveKey={this.state.selectedTab}>
                <div style={{ marginTop: "2rem" }} className="kt-quick-panel__nav">
                    <Nav
                        onSelect={this.setTab}
                        className="nav nav-tabs nav-tabs-line nav-tabs-bold nav-tabs-line-3x nav-tabs-line-brand kt-notification-item-padding-x"
                    >
                        <SideBarNavigationTabAction
                            partyHasRoleInContract={this.props.contractTemplate.parties.supplierExist}
                            title={contractTemplate.resources.SUPPLIER_NAME}
                            eventKey="1"
                            actions={pendingDrafts.SUPPLIER}
                        />
                        <SideBarNavigationTabAction
                            partyHasRoleInContract={this.props.contractTemplate.parties.pmExist}
                            title={contractTemplate.resources.PM_NAME}
                            eventKey="2"
                            actions={pendingDrafts.PM}
                        />
                        <SideBarNavigationTabAction
                            partyHasRoleInContract={this.props.contractTemplate.parties.supervisorExist}
                            title={contractTemplate.resources.SUPERVISOR_NAME}
                            eventKey="3"
                            actions={pendingDrafts.SUPERVISOR}
                        />
                        <SideBarNavigationTabAction
                            partyHasRoleInContract={this.props.contractTemplate.parties.clientExist}
                            title={contractTemplate.resources.CLIENT_NAME}
                            eventKey="4"
                            actions={pendingDrafts.CLIENT}
                        />
                    </Nav>
                </div>
                
                <div className="kt-quick-panel__content">
                    <Tab.Content>
                        <Tab.Pane eventKey="1">
                            <PendingDraftGroup
                                key={this.props.skey + "GRP_1"}
                                skey={this.props.skey + "GRP_1"}
                                actionsObj={pendingDrafts.SUPPLIER}
                                panelCloseBtnRef={this.props.panelCloseBtnRef}
                                isOpen={this.props.isOpen}
                            />
                        </Tab.Pane>
                        <Tab.Pane eventKey="2">
                            <PendingDraftGroup
                                key={this.props.skey + "GRP_2"}
                                skey={this.props.skey + "GRP_2"}
                                actionsObj={pendingDrafts.PM}
                                panelCloseBtnRef={this.props.panelCloseBtnRef}
                                isOpen={this.props.isOpen}
                            />
                        </Tab.Pane>
                        <Tab.Pane eventKey="3">
                            <PendingDraftGroup
                                key={this.props.skey + "GRP_3"}
                                skey={this.props.skey + "GRP_3"}
                                actionsObj={pendingDrafts.SUPERVISOR}
                                panelCloseBtnRef={this.props.panelCloseBtnRef}
                                isOpen={this.props.isOpen}
                            />
                        </Tab.Pane>
                        <Tab.Pane eventKey="4">
                            <PendingDraftGroup
                                key={this.props.skey + "GRP_4"}
                                skey={this.props.skey + "GRP_4"}
                                actionsObj={pendingDrafts.CLIENT}
                                panelCloseBtnRef={this.props.panelCloseBtnRef}
                                isOpen={this.props.isOpen}
                            />
                        </Tab.Pane>
                    </Tab.Content>
                </div>
            </Tab.Container>
        );
    }
}

const mapStateToProps = store => ({
    contractDashboard: store.contract.dashboard,
    contractTemplate: store.contract.template,
    pendingDrafts: store.contract.pendingDrafts,
});

export default connect(mapStateToProps)(ContractSidePanelDrafts)